namespace advisorop.components.identity {

    /// A thin, always-visible strip across the top of every signed-in page, shown only while the
    /// user has no second factor. It is deliberately not dismissible: the point is that it stays
    /// there until the account is actually protected.
    ///
    /// The bar adds a class to <body> when it shows, so the stylesheet can push the content band
    /// down by exactly the bar height. Without that the bar would sit over the top of the page
    /// content, because the header and the small-header band are both position:fixed.
    class TwoFactorBarController {

        setup: domains.identity.ITwoFactorSetup = {};
        profileLink: string;
        visible = false;

        static $inject = ["identityService"];
        constructor(private identityService: services.IdentityService) {
        }

        private setBodyClass(on: boolean): void {
            const body = angular.element(document.body);
            if (on) {
                body.addClass("has-2fa-bar");
            } else {
                body.removeClass("has-2fa-bar");
            }
        }

        $onInit(): void {
            // .then rather than async/await on purpose: these are $q promises, and resolving them
            // through the digest is what makes the binding update without a manual $apply.
            this.identityService.getUserPromise().then(user => {

                // An impersonator is not the account owner, and the bar has no way to say so.
                // getMyTwoFactorSetup reads the signed-in login, which while impersonating is the
                // impersonated user - so the bar would report somebody else's account as "your
                // account". Worse, it would offer an action that cannot succeed: EnableOwnTwoFactor
                // refuses an impersonator by design, because a second factor set up by someone else
                // would deliver its codes to someone else.
                //
                // An administrator who needs two-factor authentication switched on for a user does
                // it from that user's record - see SetTwoFactorEnabled - not from here.
                if (user.impersonated) {
                    this.visible = false;
                    this.setBodyClass(false);
                    return;
                }

                if (user.systemLoginType === domains.SystemLoginType.SERVICER) {
                    this.profileLink = "/servicer/userprofile";
                } else if (user.systemLoginType === domains.SystemLoginType.ADVISOR) {
                    this.profileLink = "/advisor/userprofile";
                } else {
                    this.profileLink = "/investor/userprofile";
                }

                // Asked for fresh rather than read off the cached user: the cached copy can be
                // several sessions old, and a bar that nags someone who already turned 2FA on is
                // the fastest way to make people stop reading it.
                this.identityService.getMyTwoFactorSetup()
                    .then(response => {
                        this.setup = response.data || {};
                        this.visible = !this.setup.twoFactorEnabled;
                        this.setBodyClass(this.visible);
                    }, err => {
                        // Never let a failed check break the page chrome - but say so, because a
                        // hidden bar and a broken endpoint look identical from the page, and that
                        // cost real time the first time it happened.
                        console.warn("Two-factor reminder bar: could not read the setup state, so the bar is hidden.",
                            err && err.status, err && err.data);
                        this.visible = false;
                        this.setBodyClass(false);
                    });

            }, err => {
                console.warn("Two-factor reminder bar: could not identify the signed-in user.", err);
                this.visible = false;
                this.setBodyClass(false);
            });
        }

        $onDestroy(): void {
            this.setBodyClass(false);
        }
    }

    class TwoFactorBar implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {};
            this.controller = TwoFactorBarController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/identity-module/components/two-factor-bar.html';
        }
    }
    angular.module(Constants.APP).component("twoFactorBar", new TwoFactorBar());
}
